import styled from 'styled-components';

import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

import { media } from '../Dashboard/media';

const Paragraph = styled.p`
  margin: 0;
  padding: 0;

  color: ${colors.shade80};
  font-size: 14px;
  font-weight: 400;

  @media (min-width: ${media.large}) {
    font-size: 20px;
  }
`;

export default Paragraph;
